/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllingKeyFiguresResponse } from '../models/ControllingKeyFiguresResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingKeyFiguresService {
    /**
     * list key controlling figures
     * @param tenantId tenant_id
     * @returns ControllingKeyFiguresResponse successful
     * @throws ApiError
     */
    public static getControllingKeyFigures(
        tenantId: string,
    ): CancelablePromise<ControllingKeyFiguresResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/key_figures',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
}
